function change_variant_custom(e) {

  //autoSelectSingleOptions();

  //hideUnavailableOptions(all_variants);

  if (document.querySelectorAll('.variant-switch-input.disabled:checked').length > 0) {
    var disabledInputs = document.querySelectorAll('.variant-switch-input.disabled:checked');
    var disabledInputsArr = Array.prototype.slice.call(disabledInputs);
    disabledInputsArr.forEach(function(disabledInput, index){
      if (disabledInput.closest('.product-form__input').querySelector('input:not(.disabled)')) {
        disabledInput.closest('.product-form__input').querySelectorAll('input:not(.disabled)')[0].click();
      }
    });
  }
 

  //const variantIdInput = document.querySelector('input[name="id"]');
  // if (variantIdInput) {
  //   variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
  // }
}

document.querySelector('.product-variant-id').addEventListener('change', change_variant_custom);


function warning_popup(e) {
  if (e.target.classList.contains('warning-popup-btn') || (e.target.closest('button') && e.target.closest('button').classList.contains('warning-popup-btn'))) {
    e.preventDefault();
    if (document.querySelector('.product-warning-popup')) {
      document.querySelector('.product-warning-popup').classList.add('open');
    }
  }
  if (e.target.classList.contains('warning-popup-close-btn') || e.target.classList.contains('product-warning-popup__container') || e.target.classList.contains('product-warning-popup')) {
    e.preventDefault();
    if (document.querySelector('.product-warning-popup.open')) {
      document.querySelector('.product-warning-popup').classList.remove('open');
    }
  }
  if (e.target.classList.contains('product-warning-popup__add-to-cart') && document.querySelector('.product-form__submit.warning-popup-btn')) {
    document.querySelector('.warning-popup-btn').classList.remove('warning-popup-btn');
    document.querySelector('.product-form__submit').click();
  }
}
window.addEventListener('click',warning_popup);

// function autoSelectSingleOptions() {
//   document.querySelectorAll('fieldset.product-form__input').forEach((fieldset) => {
//     const enabledOptions = Array.from(fieldset.querySelectorAll('input[type="radio"]:not(.disabled)'));
//     const alreadySelected = enabledOptions.find((input) => input.checked);
//     if (!alreadySelected && enabledOptions.length === 1) {
//       enabledOptions[0].click();
//       enabledOptions[0].dispatchEvent(new Event('change', { bubbles: true }));
//     }
//   });
// }

function removeFirstPriceBlockOnMobile() {
    const mediaQuery = window.matchMedia('(max-width: 749px)');
    function handleMediaChange(event) {
        if (event.matches) {
            const priceBlocks = document.querySelectorAll('.product-block.product-block--price');       
            if (priceBlocks.length >= 2) {
                priceBlocks[0].remove();
            }
        }
    }
    
    handleMediaChange(mediaQuery);
    mediaQuery.addEventListener('change', handleMediaChange);
}

document.addEventListener('DOMContentLoaded', removeFirstPriceBlockOnMobile);
//window.addEventListener('load', removeFirstPriceBlockOnMobile);